import { ColumnButton } from 'lib/components/ColumnButton';
import { DeadlineSettings } from 'lib/types/deadlines';
import { TrashIcon } from '@heroicons/react/24/outline';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import ColumnDatePicker from 'components/ColumnDatePicker';

type SelectedDateRowProps = {
  id: string;
  deadlines?: DeadlineSettings[];
  publicationDate: string;
  onRemoveRowClick: () => void;
  onRowDateChange: (date: Date) => void;
  disable: {
    changeDate: boolean;
    removeDate: boolean;
  };
  isValid?: boolean;
  showDelete: boolean;
  shouldDisableDate: (date: MaterialUiPickersDate) => boolean;
};

function RemovableDate({
  id,
  publicationDate,
  onRemoveRowClick,
  onRowDateChange,
  disable,
  isValid = true,
  showDelete,
  shouldDisableDate
}: SelectedDateRowProps) {
  return (
    <div className="flex space-x-2">
      <ColumnDatePicker
        id={id}
        value={publicationDate}
        shouldDisableDate={shouldDisableDate}
        disabled={disable.changeDate}
        onChange={date => {
          if (date) {
            onRowDateChange(date);
          }
        }}
        format="MM/dd/yyyy"
        momentFormat="MMMM Do"
        placeholderText="MM/DD/YYYY"
        errorText={!isValid ? 'Invalid publication date' : undefined}
        fullWidth
      />
      {!disable.removeDate && showDelete && (
        <ColumnButton
          destructive
          secondary
          startIcon={<TrashIcon className="w-5 h-5" />}
          onClick={onRemoveRowClick}
          type="button"
          aria-label="Delete"
        />
      )}
    </div>
  );
}

export default RemovableDate;
